///
/// EarthBrowser
///
/// Created by Matt Giger on 10/30/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Screen rectangles currently covered by labels, shared between the
/// independent label systems (city/weather labels, division names, road
/// shields) so that each can declutter against what the others have already
/// placed. Publishers overwrite their own set each frame; consumers read
/// everyone else's. One-directional by design: a consumer yields to the
/// published rects, it never pushes them aside, so a publisher's own
/// placement/hysteresis logic is unaffected.
///

export interface LabelRect {
	left: number
	top: number
	right: number
	bottom: number
}

class LabelOccupancyRegistry {
	private rects = new Map<string, LabelRect[]>()

	/** Replace the rects published under an owner key */
	public publish(owner: string, rects: LabelRect[]): void {
		this.rects.set(owner, rects)
	}

	/** Drop an owner's rects (layer hidden or destroyed) */
	public clear(owner: string): void {
		this.rects.delete(owner)
	}

	/** Rects published by every owner except the given one */
	public others(owner: string): LabelRect[] {
		const result: LabelRect[] = []
		for (const [key, rects] of this.rects) {
			if (key !== owner) {
				for (const rect of rects) {
					result.push(rect)
				}
			}
		}
		return result
	}
}

export const labelOccupancy = new LabelOccupancyRegistry()
